import { render } from "./ConfirmationModalBody.vue?vue&type=template&id=3bb25459&scoped=true&ts=true"
import script from "./ConfirmationModalBody.vue?vue&type=script&lang=ts"
export * from "./ConfirmationModalBody.vue?vue&type=script&lang=ts"

import "./ConfirmationModalBody.vue?vue&type=style&index=0&id=3bb25459&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb25459"]])

export default __exports__